import { render, staticRenderFns } from "./PriceChangeHistory.vue?vue&type=template&id=507844ba&scoped=true&"
import script from "./PriceChangeHistory.vue?vue&type=script&lang=js&"
export * from "./PriceChangeHistory.vue?vue&type=script&lang=js&"
import style0 from "./PriceChangeHistory.vue?vue&type=style&index=0&id=507844ba&scoped=true&lang=css&"
import style1 from "./PriceChangeHistory.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507844ba",
  null
  
)

export default component.exports